import { useSearchParams } from 'next/navigation';
import React from 'react';

export default function SwitchFilter({ title, name, onChange }) {
  const searchParams = useSearchParams();
  const checked = searchParams.get(name) ? true : false;

  return (
    <div>
      <div className="form-check  text-sm form-switch flex justify-between px-4 py-3 border border-light-gray-400 rounded-md mb-3.5">
        <span>{title}</span>
        <input
          className="form-check-input appearance-none w-9 ml-2 text-sm  rounded-full  h-5 align-top  bg-no-repeat bg-contain bg-gray-300 focus:outline-none cursor-pointer shadow-sm"
          type="checkbox"
          role="switch"
          checked={checked}
          onChange={onChange}
          name={name}
        />
      </div>
    </div>
  );
}
